import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Card, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="max-w-md text-center">
        <p className="font-display text-8xl font-extrabold tracking-display text-primary">404</p>
        <CardTitle>{t('notFound.title')}</CardTitle>
        <p className="mt-2 text-sm text-on-surface-variant">{t('notFound.description')}</p>
        <Link to="/" className="mt-5 block"><Button fullWidth>{t('notFound.goHome')}</Button></Link>
      </Card>
    </div>
  );
}
